import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import EditFormTableWidget from '../dynamicForm/EditFormTableWidget'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import EditButton from '../../../components/buttons/editButton/EditButton'
import ViewFormTableWidget from '../dynamicForm/ViewFormTableWidget'
import HTMLWidget from '../../HTMLWidget'
import { SUB_PROJECT_ID } from '../../../constants/constants'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { doneLoading, startLoading } from '../../../utils/loading'
import { DEFAULT_ERR_MSG, DELETE_SUCCESS_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import notification from '../../../utils/notification'
import {
  delFormOtherSupportById,
  saveFormOtherSupport,
} from '../../../redux/actions/subProjectProposal'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import { cloneDeep } from 'lodash-es'
import { setAlertMessage } from '../../../utils/messageUtil'

export default function OtherSupportWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props

  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()

  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isEditRow, setIsEditRow] = useState(false)
  const [notiMsg, setNotiMsg] = useState()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [objectDatas, setObjectDatas] = useState(props.schema?.objects)
  const [editId, setEditId] = useState()

  const mode = location.search.substring(1)
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await saveFormOtherSupport(subProjectId, request)
      if (response) {
        setFormSchema(response)
        setIsEditRow(false)
        setAlertMessage('success', SAVE_SUCCESS_MSG, setNotiMsg)
      } else {
        setAlertMessage('error', DEFAULT_ERR_MSG, setNotiMsg)
      }
    } catch (e) {
      // console.log('error', e)
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG, setNotiMsg)
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleDel = async (data) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await delFormOtherSupportById(subProjectId, data.id)
      if (response) {
        setFormSchema(response)
        notification.open('success', {
          title: DELETE_SUCCESS_MSG,
          duration: 2500,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 2500,
        })
      }
    } catch (e) {
      //console.log('error', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let values = []

    formSchema.objects?.forEach((e) => {
      if (e.type != 'RUNNING') {
        var value = data[e.name] || null

        values.push({
          key: e.id,
          name: e.name,
          value: value,
          type: e.type,
        })
      }
    })

    let request = {
      id: isEditRow ? editId : 'NEW_',
      values: values,
    }

    handleSave(request)
  }

  const onEdit = (data) => {
    console.log('data', data)
    var obj = cloneDeep(objectDatas)

    obj.forEach((e) => {
      e.value = data?.values?.find((v) => v.key == e.name)?.value
    })

    console.log('obj : ', obj)

    setObjectDatas(obj)

    setEditId(data.id)
    setIsEditRow(true)
  }

  const onCancel = () => {
    setIsEditRow(false)
    setEditId('')
    setObjectDatas(formSchema.objects)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {isLoading && <OverlayLoader />}

      {/* <WarningMessage message={formSchema?.feedbackBySubject} /> */}

      <HTMLWidget
        style={{ marginTop: 10, marginBottom: 10, marginLeft: 10 }}
        data={formSchema.detail}
      />
      {isEdit && showCommandButton && (
        <>
          <EditFormTableWidget
            schema={formSchema}
            objectDatas={objectDatas}
            preView={mode}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            isEdit={isEditRow}
            handleSubmit={handleSubmit}
            notiMsg={notiMsg}
            setNotiMsg={setNotiMsg}
            onSave={onSubmit}
            onCancel={onCancel}
          />
        </>
      )}

      <ViewFormTableWidget
        schema={formSchema}
        enableEdit={isEdit && showCommandButton}
        onDelete={handleDel}
        onEdit={onEdit}
      />

      {showCommandButton && !mode && (
        <div className="right">
          <hr />

          {isEdit ? (
            <div>
              <ViewButton
                icon="backward"
                onClick={() => {
                  onChangeIsEdit(!isEdit)
                }}
                disabled={isLoading}
              >
                {'ดูรายการ' + (formSchema.buttonText ? formSchema.buttonText : '')}
              </ViewButton>
            </div>
          ) : (
            <EditButton
              onClick={() => {
                onChangeIsEdit(!isEdit)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
              disabled={isLoading}
            >
              {'เพิ่ม/แก้ไข' + (formSchema.buttonText ? formSchema.buttonText : '')}
            </EditButton>
          )}
        </div>
      )}
    </Panel>
  )
}
